import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { IconButton } from '../Button/IconButton';

import { colors } from '../../styles/colors/';

import EditIcon from '../Icons/EditIcon';
import DeleteIcon from '../Icons/DeleteIcon';

const StyledSubcontentContainer = styled.div`
  width: ${(props) => `${props.width}px` || '100%'};
  height: ${(props) => `${props.height}px` || '100%'};
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: ${(props) => (props.reducedPadding ? '8px 16px' : '16px')};
  background-color: ${(props) => colors['sand']['1']};
`;

const StyledHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const StyledBodyContainer = styled.div`
  margin-top: 15px;
`;

const StyledLabel = styled.div`
  font-size: ${(props) => props.labelSize};
  font-weight: 600;
`;

const StyledSubLabel = styled.div`
  font-size: ${(props) => props.sublabelSize};
  font-weight: 400;
`;

const StyledIconContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 4px;
`;

/**
 * Primary UI component for user interaction
 */
const Subcontent = ({
  width,
  height,
  label,
  sublabel,
  onEditClick,
  onDeleteClick,
  disableDelete,
  hideEdit,
  hideDelete,
  editTooltipText,
  deleteTooltipText,
  collapsed,
  isMobile,
  children,
  ...props
}) => {
  const rightMargin = hideDelete ? 0 : 2.25;
  const topMargin = 0.5;
  const reducedPadding = collapsed || isMobile;

  let labelSize = '18px';
  let sublabelSize = '14px';

  if (isMobile) {
    if (collapsed && !!sublabel) {
      sublabelSize = '16px';
    } else if (collapsed) {
      labelSize = '16px';
    }
  } else {
    if (collapsed && !!sublabel) {
      sublabelSize = '14px';
    } else if (collapsed) {
      labelSize = '14px';
    }
  }

  return (
    <StyledSubcontentContainer
      width={width}
      height={height}
      reducedPadding={reducedPadding}
      {...props}
    >
      <StyledHeaderContainer>
        <div>
          <StyledLabel labelSize={labelSize}>{label}</StyledLabel>
          <StyledSubLabel sublabelSize={sublabelSize}>{sublabel}</StyledSubLabel>
        </div>
        <StyledIconContainer>
          {!hideEdit && (
            <IconButton
              alt="edit_icon"
              iconSvg={<EditIcon />}
              width={16}
              height={16}
              mr={rightMargin}
              mt={topMargin}
              onClick={onEditClick}
              tooltipText={editTooltipText}
              isMobile={isMobile}
            />
          )}
          {!hideDelete && (
            <IconButton
              alt="delete_icon"
              iconSvg={<DeleteIcon />}
              width={16}
              height={16}
              mt={topMargin}
              onClick={onDeleteClick}
              disabled={disableDelete}
              tooltipText={deleteTooltipText}
              isMobile={isMobile}
            />
          )}
        </StyledIconContainer>
      </StyledHeaderContainer>
      {!collapsed && <StyledBodyContainer>{children}</StyledBodyContainer>}
    </StyledSubcontentContainer>
  );
};

Subcontent.propTypes = {
  width: PropTypes.number,

  height: PropTypes.number,

  label: PropTypes.string,

  sublabel: PropTypes.string,

  onEditClick: PropTypes.func,

  onDeleteClick: PropTypes.func,

  hideEdit: PropTypes.bool,

  hideDelete: PropTypes.bool,

  disableDelete: PropTypes.bool,

  collapsed: PropTypes.bool,

  isMobile: PropTypes.bool,

  editTooltipText: PropTypes.string,

  deleteTooltipText: PropTypes.string,
};

Subcontent.defaultProps = {
  hideEdit: false,
  hideDelete: false,
  collapsed: false,
  disableDelete: false,
  isMobile: false,
};

export { Subcontent };
